/**
 * The `notify` locale namespace: the settings-section copy and the toast
 * titles. Chinese is the product copy; English mirrors it key for key.
 */

/** Simplified Chinese dictionary (the key-set source of truth). */
export const zh = {
  nav: '通知',
  'settings.title': '桌面通知',
  'settings.subtitle': '会话跑完、出错、或停下来等你确认时，弹出 Windows 通知；点通知可以回到对应会话。',
  'settings.enabled': '启用通知',
  'settings.enabledDesc': '总开关；关闭后不再弹任何通知，下面的偏好会保留。',
  'settings.sound': '提示音',
  'settings.soundDesc': '使用系统通知自带提示音；关闭后静音弹出。',
  'settings.when.title': '结束提醒',
  'settings.when.subtitle': '选择哪些结束状态需要提醒。',
  'settings.when.completed': '正常完成',
  'settings.when.error': '出错',
  'settings.when.aborted': '被中止',
  'settings.when.blocked': '被阻塞',
  'settings.when.maxTokens': '达到 Token 上限',
  'settings.pending.title': '等待确认',
  'settings.pending.subtitle': '会话停下来等你审批、回答或评审计划时提醒。',
  'settings.pending.approval': '等待审批',
  'settings.pending.question': '等待回答',
  'settings.pending.planReview': '等待计划评审',
  'settings.remind.title': '超时催办',
  'settings.remind.desc': '等待确认超过设定分钟数仍未处理时，补一条提醒（每次等待只补一次）。',
  'settings.remind.minutes': '分钟',
  'settings.test.title': '测试',
  'settings.test.desc': '发一条测试通知，确认权限与提示音正常。',
  'settings.test.button': '发送测试通知',
  'settings.sounds.title': '音效',
  'settings.sounds.desc': '给四类情况各挑一个声音，点「试听」立刻听一遍。下拉里分三组：Windows 音效 / 作者音效 / 自定义音效。文件类音效最长播 8 秒；关掉上面的「提示音」或者切回 DSH 窗口，都会立刻停。',
  'settings.sounds.finished': '任务正常结束',
  'settings.sounds.error': '任务出错',
  'settings.sounds.attention': '需要你处理（审批 / 提问 / 计划评审）',
  'settings.sounds.reminder': '超时催办',
  'settings.sounds.preview': '试听',
  'settings.sound.systemDefault': '系统提示音（叮）',
  'settings.sound.systemIm': '系统消息',
  'settings.sound.systemMail': '系统邮件',
  'settings.sound.systemCalendar': '系统日历',
  'settings.sound.fileDing': '叮（轻）',
  'settings.sound.fileChimes': '和弦（柔和）',
  'settings.sound.fileNotify': 'Windows 通知',
  'settings.sound.fileNotifyLegacy': '旧版通知',
  'settings.sound.fileMessageNudge': '消息轻推',
  'settings.sound.fileTada': '完成号角',
  'settings.sound.fileExclamation': '警告',
  'settings.sound.fileError': '错误',
  'settings.sound.fileCriticalStop': '严重错误',
  'settings.sound.fileAlarm1': '闹钟 1',
  'settings.sound.fileAlarm2': '闹钟 2',
  'settings.sound.fileAlarm3': '闹钟 3',
  'settings.sound.fileRing1': '铃声 1',
  'settings.sound.fileRing2': '铃声 2',
  'settings.sound.fileRing3': '铃声 3',
  'settings.sounds.groupWindows': 'Windows 音效',
  'settings.sounds.groupAuthor': '作者音效',
  'settings.sounds.groupCustom': '自定义音效',
  'settings.sounds.authorEmpty': '作者音效：暂无（放在插件 sounds/ 文件夹里）',
  'settings.sounds.customEmpty': '还没有自定义音效，点下面的「添加音效…」',
  'settings.library.title': '自定义音效',
  'settings.library.empty': '还没有自定义音效',
  'settings.library.count': '音效占用：{files} 个文件 · {size}',
  'settings.library.add': '添加音效…',
  'settings.library.remove': '删除',
  'settings.library.desc': '点「添加音效…」选一个音频文件：它会被复制到 {path}，之后原文件移动或删除都不影响。支持 .wav / .mp3 / .m4a / .aac / .wma / .flac / .ogg / .opus；除 .wav 之外，首次播放时会转成 wav 并计入下面的「转换缓存」——占用和清理都在那里。',
  'settings.library.added': '已添加：{name}',
  'settings.library.removed': '已删除',
  'settings.library.missing': '这个音效文件不在了，重新选一个或再添加一次',
  'settings.library.addFailed': '操作失败：宿主没有响应，或这个格式不支持',
  'settings.sound.silent': '静音',
  'settings.cache.label': '转换缓存',
  'settings.cache.empty': '暂无转换缓存',
  'settings.cache.inUse': '缓存占用：{files} 个文件 · {size}',
  'settings.cache.clear': '清理缓存',
  'settings.cache.cleared': '已清理 {files} 个缓存文件，释放 {size}',
  'settings.cache.failed': '清理失败：宿主没有响应',
  'settings.cache.desc': '上面「自定义音效」里非 wav 的格式，首次播放时会转成 wav 存在本机（%LOCALAPPDATA%\\dsh-notify\\sounds）。缓存随时可以清，下次播放会自动重建。',
  'notify.shortCompleted': '任务完成',
  'notify.shortError': '任务出错',
  'notify.shortAborted': '任务中止',
  'notify.shortBlocked': '任务阻塞',
  'notify.shortMaxTokens': 'Token 达上限',
  'notify.shortApproval': '等待审批',
  'notify.shortQuestion': '等待回答',
  'notify.shortPlanReview': '等待计划评审',
  'notify.shortReminder': '仍未处理',
  'notify.emptyBody': '这一轮已结束。',
  'notify.pendingBody': '有一条待处理的确认。',
  'notify.reminderBody': '已经等了 {minutes} 分钟，还没有处理。',
  'notify.testTitle': 'DSH 通知测试',
  'notify.testBody': '能看到这条通知，说明通知配置正常。',
} as const

/** The dictionary key set. */
export type NotifyKey = keyof typeof zh

/** English dictionary, keyed exactly like {@link zh}. */
export const en = {
  nav: 'Notifications',
  'settings.title': 'Desktop notifications',
  'settings.subtitle': 'A Windows toast when a session finishes, fails, or stops to ask you something; click it to return to that session.',
  'settings.enabled': 'Enable notifications',
  'settings.enabledDesc': 'Master switch; turning it off silences every notification and keeps the preferences below.',
  'settings.sound': 'Sound',
  'settings.soundDesc': 'Use the system notification sound; off shows the toast silently.',
  'settings.when.title': 'Turn outcomes',
  'settings.when.subtitle': 'Which ways of ending a turn should notify.',
  'settings.when.completed': 'Completed',
  'settings.when.error': 'Error',
  'settings.when.aborted': 'Aborted',
  'settings.when.blocked': 'Blocked',
  'settings.when.maxTokens': 'Token limit reached',
  'settings.pending.title': 'Waiting on you',
  'settings.pending.subtitle': 'Notify while a session waits for an approval, an answer, or a plan review.',
  'settings.pending.approval': 'Waiting for approval',
  'settings.pending.question': 'Waiting for an answer',
  'settings.pending.planReview': 'Waiting for a plan review',
  'settings.remind.title': 'Unanswered reminder',
  'settings.remind.desc': 'Send one extra toast when a confirmation has been waiting longer than the configured minutes (one reminder per wait).',
  'settings.remind.minutes': 'minutes',
  'settings.test.title': 'Test',
  'settings.test.desc': 'Send a test notification to confirm permission and sound.',
  'settings.test.button': 'Send a test notification',
  'settings.sounds.title': 'Sounds',
  'settings.sounds.desc': 'Pick one sound per situation; Preview plays it right away. The list has three sections: Windows sounds, author sounds and your own custom sounds. File sounds stop after 8 seconds, and also stop when sound is switched off or the DSH window regains focus.',
  'settings.sounds.finished': 'Finished normally',
  'settings.sounds.error': 'Failed',
  'settings.sounds.attention': 'Waiting on you (approval / question / plan review)',
  'settings.sounds.reminder': 'Still-waiting reminder',
  'settings.sounds.preview': 'Preview',
  'settings.sound.systemDefault': 'System chime',
  'settings.sound.systemIm': 'System message',
  'settings.sound.systemMail': 'System mail',
  'settings.sound.systemCalendar': 'System calendar',
  'settings.sound.fileDing': 'Ding (soft)',
  'settings.sound.fileChimes': 'Chimes (gentle)',
  'settings.sound.fileNotify': 'Windows notify',
  'settings.sound.fileNotifyLegacy': 'Legacy notify',
  'settings.sound.fileMessageNudge': 'Message nudge',
  'settings.sound.fileTada': 'Tada',
  'settings.sound.fileExclamation': 'Exclamation',
  'settings.sound.fileError': 'Error',
  'settings.sound.fileCriticalStop': 'Critical stop',
  'settings.sound.fileAlarm1': 'Alarm 1',
  'settings.sound.fileAlarm2': 'Alarm 2',
  'settings.sound.fileAlarm3': 'Alarm 3',
  'settings.sound.fileRing1': 'Ring 1',
  'settings.sound.fileRing2': 'Ring 2',
  'settings.sound.fileRing3': 'Ring 3',
  'settings.sounds.groupWindows': 'Windows sounds',
  'settings.sounds.groupAuthor': 'Author sounds',
  'settings.sounds.groupCustom': 'Custom sounds',
  'settings.sounds.authorEmpty': 'No author sounds (they live in the plugin\'s sounds/ folder)',
  'settings.sounds.customEmpty': 'No custom sounds yet - use Add sound… below',
  'settings.library.title': 'Custom sounds',
  'settings.library.empty': 'No custom sounds yet',
  'settings.library.count': 'Library in use: {files} file(s) · {size}',
  'settings.library.add': 'Add sound…',
  'settings.library.remove': 'Remove',
  'settings.library.desc': 'Add sound… copies the audio file you pick into {path}, so moving or deleting the original later changes nothing. .wav / .mp3 / .m4a / .aac / .wma / .flac / .ogg / .opus; anything but a wav is transcoded on its first play and shows up in the transcode cache below, where its size lives and can be cleared.',
  'settings.library.added': 'Added: {name}',
  'settings.library.removed': 'Removed',
  'settings.library.missing': 'That sound file is gone: pick another one, or add it again',
  'settings.library.addFailed': 'Failed: the host did not answer, or the format is unsupported',
  'settings.sound.silent': 'Silent',
  'settings.cache.label': 'Transcode cache',
  'settings.cache.empty': 'No transcoded sounds yet',
  'settings.cache.inUse': 'Cache in use: {files} file(s) · {size}',
  'settings.cache.clear': 'Clear cache',
  'settings.cache.cleared': 'Cleared {files} cached file(s), freed {size}',
  'settings.cache.failed': 'Clear failed: the host did not answer',
  'settings.cache.desc': 'A non-wav file from the custom sounds above is transcoded once into %LOCALAPPDATA%\\dsh-notify\\sounds. It is safe to clear: the next play rebuilds it.',
  'notify.shortCompleted': 'done',
  'notify.shortError': 'failed',
  'notify.shortAborted': 'aborted',
  'notify.shortBlocked': 'blocked',
  'notify.shortMaxTokens': 'token limit',
  'notify.shortApproval': 'needs approval',
  'notify.shortQuestion': 'needs an answer',
  'notify.shortPlanReview': 'needs a plan review',
  'notify.shortReminder': 'still waiting',
  'notify.emptyBody': 'This turn has ended.',
  'notify.pendingBody': 'There is a pending confirmation.',
  'notify.reminderBody': 'Waiting for {minutes} minutes already.',
  'notify.testTitle': 'DSH notification test',
  'notify.testBody': 'If you can see this, notifications are configured correctly.',
} satisfies Record<NotifyKey, string>

/** The locale namespace registered under ctx.locale. */
export const NS = 'notify'

/**
 * Fill one dictionary template's `{name}` placeholders.
 * @param template - dictionary text.
 * @param params - placeholder values.
 * @returns the filled text.
 */
export function fmt(template: string, params?: Record<string, string>): string {
  if (params === undefined) return template
  return template.replace(/\{(\w+)\}/g, (whole, key: string) => params[key] ?? whole)
}

declare module '@deepseek-ai/dsh-client-ui-slots' {
  interface LocaleNamespaceMap {
    /** The notification settings copy and toast titles. */
    [NS]: NotifyKey
  }
}
